import { getLigne, getDirection, getService } from '../store/line-store.js'
import { Lignes } from '../lines.js'

export class LigneDestinationElement extends HTMLElement {
	constructor() {
		super()

		const shadow = this.attachShadow({ mode: 'open' })

		this.button = document.createElement('span')
		this.button.textContent = this.getAttribute('ligne') || 'Ligne ?'

		const style = document.createElement('style')
		style.textContent = `
      span {
        color: ${this.getAttribute('color') || 'white'};
        border: none;
        padding: 8px 16px;
        border-radius: 16px;
        margin: 6px;
      }
    `
		this.setLine()
		shadow.appendChild(style)
		shadow.appendChild(this.button)

		document.addEventListener('ligne-selected', (event) => {
			this.setLine()
		})
	}

	setLine() {
		if (!Lignes || Lignes.length === 0) return false
		const name = getLigne()
		let ligne = Lignes.find((l) => l.ligne === name)

		let index = 0
		let serviceName = getService()
		index = ligne.services.findIndex((s, i) => s.name === serviceName)

		if (ligne)
			this.button.textContent =
				getDirection() == 'Retour'
					? Object.values(ligne.services.at(index).retour).at(-1).name
					: Object.values(ligne.services.at(index).aller).at(-1).name
	}
}

customElements.define('ligne-destination', LigneDestinationElement)
